import { SignIn } from "@clerk/clerk-react";
import React from "react";

const Login: React.FC = () => {
  return (
    <div className="flex flex-col gap-6 justify-center items-center h-screen bg-zinc-900">
      <p className="text-lg font-semibold text-white uppercase">
        We're happy to see you!
      </p>
      <h1 className="text-4xl font-bold text-yellow-500">
        Software For Movers
      </h1>
      <SignIn />
    </div>
  );
};

export default Login;
